export const jobNameMaxLength = 150

export const isValidJobName = (name: string | null | undefined): boolean => {
  const trimmed = (name ?? '').trim()
  return trimmed.length > 0 && trimmed.length <= jobNameMaxLength
}
